import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
import { Container, Row, Col, Form } from "react-bootstrap"
import ScrollAnimation from 'react-animate-on-scroll';
import { navigate, useMatch } from "@reach/router"

import "./TopBar.scss"
const TopBar = ({ id, crm_id, search_type }) => {

    const [index, setIndex] = useState(0);
    const [algoliaResult, setAlgoliaResult] = useState([]);
    const [searchResultPath, setSearchResultPath] = useState("/property/for-sale/in-kent/");
    let initialViewProperty=localStorage.getItem("initialViewProperty") && (localStorage.getItem("initialViewProperty") == crm_id || localStorage.getItem("initialViewProperty") == id)

    useEffect(() => {
        let algolia = localStorage.getItem('algoliaResult');
        let searchPath = localStorage.getItem('searchResultPath');
        if (algolia) {
            algolia = JSON.parse(algolia)
            let getIndex = algolia.findIndex(a => a.objectID === id);
            if(crm_id){
                getIndex = algolia.findIndex(a => a.crm_id === crm_id);
            }
            setIndex(getIndex);
            setAlgoliaResult(algolia);
        }
        if(searchResultPath){
            setSearchResultPath(searchPath)
        }
    }, [id, crm_id])
    let capture = "crm_id"
    let url = "/property-for-sale/";
    if (search_type == 'lettings') {
        url = "/property-to-rent/";
    } else if(search_type ==  "new_development")  {
        url = "/new-home-for-sale/";
        capture = "objectID"
    }
    return (
        <React.Fragment>
            <section className="top-menu">
                <Container>
                    <Row className="d-flex justify-content-between" >
                        {initialViewProperty &&
                            <Col className=" menu-bar d-flex align-items-center  d-none  d-sm-flex d-lg-flex" lg={6}  xs={6}>
                                <Link href={`${searchResultPath}`} className="sm-text" >Return to search results</Link>
                            </Col>
                        }
                        {algoliaResult && algoliaResult.length > 0 && index != 0 && !initialViewProperty &&
                            <Col className=" menu-bar d-flex align-items-center" lg={6} xs={6}>
                                <Link href={`${url}${algoliaResult[index-1]?.slug}-${algoliaResult[index-1]?.[capture]}`}>
                                    <i className="arrow-left"></i>
                                </Link>
                                <Link href={`${url}${algoliaResult[index-1]?.slug}-${algoliaResult[index-1]?.[capture]}`} className="sm-text" >Back to previous page</Link>
                            </Col>
                        }
                        {algoliaResult && algoliaResult.length > 0 && index != (algoliaResult.length - 1) &&
                            <Col className=" menu-bar d-flex align-items-center ms-auto justify-content-end" lg={6} xs={6}>

                                <Link href={`${url}${algoliaResult[index+1]?.slug}-${algoliaResult[index+1]?.[capture]}`} className="sm-text me-2">View next property</Link>
                                <Link href={`${url}${algoliaResult[index+1]?.slug}-${algoliaResult[index+1]?.[capture]}`} >
                                    <i className="arrow-right"></i>
                                </Link>
                            </Col>
                        }
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    )
}
export default TopBar
